import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {WellAssignmentMethod} from 'samples/plate-maps/PlateMapConstants';
import {FONT_WEIGHT_PROXIMA_SEMIBOLD} from 'styles/FontConstants';
import {ButtonSize} from 'ui-library/buttons/Button';
import ToggleGroup from 'ui-library/ToggleGroup';

// Pulled up here to be used immediately below in the display snippet constant
const styles = StyleSheet.create({
  semibold: {
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
  },
});

const WELL_ASSIGNMENT_METHOD_TO_DISPLAY: {[fillMethod in WellAssignmentMethod]: JSX.Element} = {
  [WellAssignmentMethod.SPECIFY_GROUP]: (
    <>
      Add <span className={css(styles.semibold)}>all</span> sources to each well
    </>
  ),
  [WellAssignmentMethod.PATTERN]: (
    <>
      Add <span className={css(styles.semibold)}>one</span> source to each well by pattern
    </>
  ),
};

interface WellAssignmentMethodSelectorProps {
  /** The selected well assignment method */
  wellAssignmentMethod: WellAssignmentMethod;
  /** A function to update the selected well assignment method */
  setWellAssignmentMethod: (wellAssignmentMethod: WellAssignmentMethod) => void;
}

export default function WellAssignmentMethodSelector({
  wellAssignmentMethod,
  setWellAssignmentMethod,
}: WellAssignmentMethodSelectorProps): JSX.Element {
  return (
    <ToggleGroup
      selection={wellAssignmentMethod}
      onChangeSelection={(value: WellAssignmentMethod) => {
        setWellAssignmentMethod(value);
      }}
      size={ButtonSize.MEDIUM}
      isFullWidth={true}
      options={[
        {
          id: WellAssignmentMethod.PATTERN,
          buttonProps: {text: WELL_ASSIGNMENT_METHOD_TO_DISPLAY[WellAssignmentMethod.PATTERN]},
        },
        {
          id: WellAssignmentMethod.SPECIFY_GROUP,
          buttonProps: {text: WELL_ASSIGNMENT_METHOD_TO_DISPLAY[WellAssignmentMethod.SPECIFY_GROUP]},
        },
      ]}
      wrap={true}
    />
  );
}
